import {
    Component,
    EventEmitter,
    Input,
    Output,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { CheckboxComponent } from "@components/checkbox/checkbox.component";
import { SelectorComponent } from "@components/selector/selector.component";
import { of } from "rxjs";
import { IRadiobuttonItem } from "~app/common/components/radiobuttongroup/radiobutton/IRadiobuttonItem";
import { DisabledControlDirective } from "~app/common/directives/disabled-control/disabled-control.directive";
import { HandelssortimentDTO } from "~app/common/models/handelssortiment/HandelssortimentDTO";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { IValidationContext } from "~app/common/validation/IValidationContext";
import {
    IHandelssortimentSearchParamsModel,
    IInmatningshandelssortiment,
    ISearchViol3HandelssortimentModel
} from "~app/features/forsaljning/handelssortiment/handelssortiment.models";
import { HandelssortimentService } from "../../handelssortiment.service";

@Component({
    selector: "rask-handelssortiment-matning",
    styleUrls: ["./matning.component.scss"],
    templateUrl: "./matning.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CheckboxComponent,
        SelectorComponent,
        DisabledControlDirective
    ]
})
export class MatningComponent {
    @Input() form: UntypedFormGroup;
    @Input() handelssortiment: HandelssortimentDTO;
    @Output() handelssortimentChange = new EventEmitter();
    handelssortimentSearchParams: IHandelssortimentSearchParamsModel;
    kvalitetsklassningRadiobuttons: IRadiobuttonItem[] = [
        { key: true,
            value: "Ja" },
        { key: false,
            value: "Nej" }
    ];
    @Input() validationContext: IValidationContext;

    private readonly handelssortimentService = inject(HandelssortimentService);

    getHandelssortiment = () => this.handelssortimentService.getHandelssortimentBasData();

    searchForHandelssortiment = (searchString: string) => {
        this.handelssortimentSearchParams = { aktiv: true,
            forInmatning: true };
        this.handelssortimentSearchParams.wildcardSearch = searchString;
        return this.handelssortimentService.searchForHandelssortiment(this.handelssortimentSearchParams);
    };

    getInitSelectedHandelssortiment = (id: number) => {
        this.handelssortimentSearchParams = { aktiv: true };
        this.handelssortimentSearchParams.ids = [id];
        return this.handelssortimentService.searchForHandelssortiment(this.handelssortimentSearchParams);
    };

    getInitSelectedViolId = (id: string) => of([
        {
            identitet: id,
            namn: ""
        }
    ]);

    handelssortimentFormatter = (result: IInmatningshandelssortiment) => result ? `${result.violId} ${result.namn}` : undefined;

    handelssortimentOutputFormatter = (result: IInmatningshandelssortiment) => result ? result.id : undefined;

    inNewMode() {
        return !this.handelssortiment.id;
    }

    inmatningCheckedChanged(set: boolean) {
        if (set) {
            this.form.patchValue({
                inmatningshandelssortimentId: null
            });
        }
    }

    searchForViolId = (searchString: string) => this.handelssortimentService.searchForViolId(searchString);

    violFormatter = (result: ISearchViol3HandelssortimentModel) => result ? `${result.identitet} ${result.namn}` : undefined;

    violOutputFormatter = (result: ISearchViol3HandelssortimentModel) => result;

    violSelectedFormatter = (result: ISearchViol3HandelssortimentModel) => ObjectUtils.hasValue(result) ?  result.identitet : undefined;
}
